import MessagesMenu from './container';

export default MessagesMenu;
